export class Mensaje {
  id: string;
  pacienteNombre: string;
  pacienteApellido1: string;
  pacienteApellido2: string;
  cuerpo: string;
  asunto: string;
  leido: boolean;
  fechaEnvio: string;
  fechaLeido: string;
  profesionalNombre: string;
  profesionalApellido1: string;
  profesionalApellido2: string;
  profesionalServicio: string;
  profesionalCentro: string;
}
